import { getComposeHostItemIndex, lazyDeinitializeAddinsForItem } from 'owa-addins-core';
import protectMessage from 'owa-mail-protection/lib/utils/rms/protectMessage';
import type { ComposeViewState } from 'owa-mail-compose-store';
import { confirm } from 'owa-confirm-dialog';
import { cannotProtectMessageWithCloudAttachment } from './protectMessageAndRemoveAddin.locstring.json';
import loc from 'owa-localize';

export default function protectMessageAndRemoveAddin(
    composeViewState: ComposeViewState,
    templateId: string,
    targetWindow: Window
) {
    if (
        composeViewState.attachmentWell.docViewAttachments?.some(
            attachment => attachment.isCloudy
        ) ||
        composeViewState.attachmentWell.imageViewAttachments?.some(
            attachment => attachment.isCloudy
        )
    ) {
        confirm('', loc(cannotProtectMessageWithCloudAttachment), false, {
            targetWindow,
            hideCancelButton: true,
        });
        return;
    }

    let { protectionViewState, composeId, bodyType } = composeViewState;
    let isProtectionApplied = protectMessage(
        protectionViewState,
        composeViewState,
        templateId,
        bodyType
    );

    isProtectionApplied &&
        // add-ins need to be deinitialized, don't support IRM/SMIME
        lazyDeinitializeAddinsForItem.import().then(deinitializeAddinsForItem => {
            deinitializeAddinsForItem(getComposeHostItemIndex(composeId));
        });
}
